import { getTenantAssessmentPaths, useIsOnboardingComplete, useWorkspaceId } from "@sg-protect/shell";
import { Navigate, Outlet } from "react-router";

export function HomeZeroStateGate() {
    const workspaceId = useWorkspaceId();
    const isOnboardingComplete = useIsOnboardingComplete();

    if (isOnboardingComplete) {
        return <Navigate to={getTenantAssessmentPaths(workspaceId).home} replace />;
    }

    return <Outlet />;
}
